import '@capsule/insite-panel/panel.css'

import 'svgs/cross.svg'

import InsitePanel from './insitePanel'

const insitePanel = new InsitePanel()
insitePanel.init()
